import { IBaseMigrationItemCode } from '../../../interfaces';
import { BaseItemCodeToConditionMappingHandler } from '../../../mappings/base-item-code-to-condition';
import {
  ADAItemSourceEntity,
  D4WADAItem,
  ID4WADAItem,
} from '../../source/entities/ada-item';

export class D4WItemCodeToConditionMappingHandler extends BaseItemCodeToConditionMappingHandler<
  D4WADAItem,
  ADAItemSourceEntity
> {
  sourceEntity = new ADAItemSourceEntity();
  translateFn = (record: ID4WADAItem): IBaseMigrationItemCode => ({
    id: record.id,
    itemCode: record.itemCode,
    description: record.description,
  });
}
